var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotateMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "-11 -11 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.61 13.767c-.307.462-.805.464-1.114 0L13.651 11h1.501a3.908 3.908 0 0 0-3.903-3.903A3.908 3.908 0 0 0 7.346 11a3.908 3.908 0 0 0 3.903 3.903v1.802A5.711 5.711 0 0 1 5.545 11a5.711 5.711 0 0 1 5.704-5.705A5.711 5.711 0 0 1 16.954 11h1.501l-1.845 2.767z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateMobile);
export default __webpack_public_path__ + "static/media/rotate-mobile.8d90252cde3aa878dbbcf3f01df11047.svg";
export { ForwardRef as ReactComponent };